<template>
  <div>
    <b-row class="row-data">
      <b-col cols="12" md="6">
        <div class="login-left">
          <div class="card-body">
            <div class="text-center w-75 m-auto">
              <div class="circle-container" v-if="isTenantSubdomain">
                <div class="circle">
                  <img src="@/assets/icon/dummyLogo.png" class="icon" />
                </div>
              </div>
              <div class="title-container">
                <h3 class="company-title">{{ companyName }}</h3>
              </div>
              <h2 class="text-dark-50 text-center mt-0 font-weight-bold login-title">
                Login to your Account
              </h2>
            </div>
            <p class="text-muted my-3 login-subtitle">
              Enter your email address/username and password to access
            </p>
            <div class="form-group mb-0 text-center mt-4">
              <c-input
                class=""
                inputId="username"
                lableText="Email address/Username"
                v-model="userName"
              />
              <div class="password-input-wrapper mt-3">
                <c-input
                  class="mt-3"
                  :inputType="passwordInputType"
                  inputId="password"
                  lableText="Password"
                  v-model="password"
                />
                <img
                  :src="
                    passwordInputType === 'password'
                      ? require('@/assets/icon/passwordHideIcon.svg')
                      : require('@/assets/icon/passwordViewIcon.svg')
                  "
                  @click="togglePasswordVisibility"
                  class="password-toggle-icon"
                />
              </div>
              <div class="form-group mb-3 mt-3" v-if="!isTenantSubdomain">
                <eb-select
                  id="sl"
                  type="text"
                  v-model="role"
                  :options="selectOption"
                  placeholder="Select which way to login"
                ></eb-select>
              </div>
              <div
                class="form-group mb-3 mt-3"
                v-if="role !== 'Admin' && role !== 'Tenant' && !isTenantSubdomain"
              >
                <eb-select
                  id="tenant"
                  type="text"
                  v-model="selectedTenant"
                  label="name"
                  :options="tenantList"
                  placeholder="Select Tenant"
                ></eb-select>
              </div>
              <div class="form-group mb-0 text-center mt-4">
                <button class="btn btn-primary btn-lg mr-2 login-btn" @click="login">
                  {{ loading ? "" : "LOG IN" }}
                  <div class="spinner-border btn-loader" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                  </div>
                </button>
              </div>
              <div class="text-center mt-2">
                <router-link to="/recoverpw">
                  <span style="color: blue; font-weight: bold"> Forgot password? </span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="text-center">
            <img src="@/assets/icon/nipige.svg" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="side-logo d-none d-md-block"> </b-col>
    </b-row>
  </div>
</template>
<script>
import { login } from "../../services/auth";
import cInput from "@/components/FormElements/CustomInput";
import ebInput from "@/components/FormElements/Input.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-select/dist/vue-select.css";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userName: "",
      password: "",
      role: "",
      loading: false,
      selectedTenant: null,
      domain: "",
      passwordInputType: "password",
      companyName: "NIPIGE",
    };
  },
  components: {
    ebInput,
    ebSelect,
    cInput,
  },
  methods: {
    ...mapActions({
      GetTenantList: "tenant/fetchTenantsListLite",
    }),
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isPermission(perm) {
      return perm && perm.name;
    },
    validatePhone(phone) {
      let re = /^\d{10}$/;
      return re.test(String(phone));
    },
    isEmailOrPhone() {
      let code = 0;
      if (this.validateEmail(this.userName)) {
        code = 1;
      }
      if (this.validatePhone(this.userName)) {
        code = -1;
      }
      return code;
    },
    togglePasswordVisibility() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },
    async login() {
      const selectedUserType = this.role.toUpperCase();
      if (this.isTenantSubdomain) {
        this.role = "Tenant";
      }
      if (this.role.length > 0) {
        if (this.role !== "Admin" && this.role !== "Tenant") {
          this.role = "Partner";
        }
        try {
          if (this.userName) {
            this.loading = true;
            let code = this.isEmailOrPhone();
            let opts = {
              password: this.password,
            };
            if (this.role !== "Admin" && this.role !== "Tenant") {
              opts.userType = selectedUserType;
            }
            if (code === 1) {
              opts.email = this.userName;
            } else if (code == -1) {
              opts.phone = this.userName;
            } else {
              opts.userName = this.userName;
            }
            sessionStorage.setItem("userRole", this.role);
            if (this.role === "Partner") {
              sessionStorage.setItem("nipige:key", this.selectedTenant._id);
            }
            let response = await login(this.role, opts);
            // check for force password update for tenant or partner.
            if (
              this.role === "Partner" &&
              response.response.user.authentication.forceChangePass
            ) {
              sessionStorage.setItem(
                "nipige:forcechangepass",
                JSON.stringify({
                  type: "partner",
                  token: response.response.token,
                })
              );
              this.$router.push("/changepassword");
              return false;
            } else if (
              response.response.user.authentication.forceChangePass &&
              this.isTenantSubdomain &&
              this.role === "Tenant"
            ) {
              sessionStorage.setItem(
                "nipige:forcechangepass",
                JSON.stringify({
                  type: "Tenant",
                  token: response.response.token,
                })
              );
              this.$router.push("/changepassword");
              return false;
            }
            this.$store.dispatch("auth/setUserRole", this.role);
            const { user, token } = response.response;
            const { authorization, authentication, _id, address } = user;
            await this.$store.dispatch("permission/fetchPermissionsByUser", {
              token: token,
              data: authorization.roles,
            });
            const permissions = await this.$store.getters[
              "permission/GetUserPermissions"
            ];

            let permissionObj = {};
            for (let i = 0; i < permissions.length; i++) {
              if (this.isPermission(permissions[i].permission)) {
                permissionObj[permissions[i].permission.name] = 1;
              }
            }
            let userCatalog = [];
            // If logged in with Tenant
            if (this.role === "Tenant") {
              sessionStorage.setItem("userName", this.userName);
              this.$store.dispatch(
                "auth/setCatalog",
                response.response.user.agreement.businessSegmentInfo
              );
              userCatalog = response.response.user.agreement.businessSegmentInfo;
              if (userCatalog.length > 0) {
                this.$store.dispatch(
                  "tenant/setTenantCatalogAccess",
                  userCatalog[0]["categoryType"]
                );
              }
              permissionObj["READ_FAQ"] = 1;
              permissionObj["CREATE_SETUP"] = 1;
              permissionObj["LIST_PARTNER_APPROVAL_REQUEST"] = 1;
              permissionObj["GET_PARTNER_CUSTOMER_DETAILS"] = 0;
              permissionObj["PAYMENT_RECORD"] = 1;
            }
            // If logged in with Admin
            else if (this.role === "Admin") {
              this.$store.dispatch("auth/setCatalog", []);
              permissionObj["PARTNER_LIST"] = 0;
              permissionObj["CREATE_ADMIN"] = 0;
              permissionObj["CREATE_PARTNER"] = 0;
              permissionObj["GET_ORDER_LIST_IN_ALL_STATES_BY_SELLER_BY_NO_OF_DAYS"] = 0;
              permissionObj["PARTNER_LIST_LITE"] = 0;
              permissionObj["CUSTOMER_SEARCH"] = 0;
              permissionObj["GET_PARTNER_CUSTOMER_DETAILS"] = 0;
              permissionObj["LIST_PARTNER_APPROVAL_REQUEST"] = 0;
            }
            // If logged in with Partners
            else if (this.role === "Partner") {
              permissionObj["READ_FAQ"] = 1;
              permissionObj["CREATE_SETUP"] = 1;
              if (user.category !== "DISTRIBUTOR" && user.category !== "DEALER") {
                permissionObj["SUB_OFFICE_HIERARCHY"] = 1;
                permissionObj["GET_PARTNER_CUSTOMER_DETAILS"] = 0;
              }
              if (user.category === "DISTRIBUTOR") {
                permissionObj["LIST_PARTNER_APPROVAL_REQUEST"] = 1;
                permissionObj["PAYMENT_RECORD"] = 1;
              }
              if (
                user.category === "SELLER" &&
                response.response.user.preferences.manageOwnCustomer
              ) {
                permissionObj["GET_PARTNER_CUSTOMER_DETAILS"] = 1;
              }
              userCatalog = response.response.user.agreement.marketSegment;
              this.$store.dispatch(
                "auth/setCatalog",
                response.response.user.agreement.marketSegment
              );
            }
            const userObj = {
              ...authentication,
              _id,
              catalogInfo: userCatalog,
              permissions: permissionObj,
              token,
              role: this.role,
              userLogo: "img/avatars/6.jpg",
            };
            this.loading = false;
            if (this.role === "Partner") {
              userObj.category = user.category;
              userObj.tenant = response.response.user.tenant;
              userObj.userLogo = response.response.user.organization.logo.url;
              if (response.response.user.parentPartner) {
                userObj.parentPartner = response.response.user.parentPartner;
              }
            }
            if (this.role === "Tenant") {
              userObj.category = user.category;
              userObj.userLogo = response.response.user.company.logo;
              userObj.enableManufacturer = user.preferences.enableManufacturer
                ? user.preferences.enableManufacturer
                : false;
              if (response.response.user.agreement) {
                userObj.agreement = response.response.user.agreement;
              }
            }
            if (this.role === "Partner" && response.response.user.agreement) {
              userObj.agreement = response.response.user.agreement;
            }
            sessionStorage.setItem("userLogin", JSON.stringify(userObj));
            this.$store.dispatch("auth/loginUser", userObj);
            if (this.isTenantSubdomain) {
              this.$router.push("/profile/profile-info");
            } else {
              this.$router.push("/home"); 
            }
          }
        } catch (error) {
          this.role = selectedUserType;
          this.$toasted.error(error.message.message);
          this.loading = false;
        }
      } else {
        this.$toasted.error("please select login way");
      }
    },
    getTenantFromSubdomain() {
      return this.domain.split(".")?.shift();
    },
    async getTenantDetails() {
      if (!this.isTenantSubdomain) {
        return;
      }
      const payload = {
        subDomain: this.getTenantFromSubdomain(),
        // subDomain: "valley",
      };
      const tenant = await this.$store.dispatch(
        "tenant/getTenantDetailsBySubDomain",
        payload
      );
      this.icon = tenant?.company?.logo || "";
      this.companyName = tenant?.company?.name || "";
      sessionStorage.setItem("companyName", JSON.stringify(tenant?.company?.name));
      sessionStorage.setItem("theme", JSON.stringify(tenant.preferences.theme));
      const primaryColor = tenant?.preferences?.theme?.primaryColor?.color;
      const secondaryColor = tenant?.preferences?.theme?.secondaryColor?.color;
      const tertiaryColor = tenant?.preferences?.theme?.tertiaryColor?.color;
      const fontColor = tenant?.preferences?.theme?.font?.color || "";
      // Set the value of variable
      document.documentElement.style.setProperty("--primary", primaryColor);
      document.documentElement.style.setProperty("--secondary", secondaryColor);
      document.documentElement.style.setProperty("--tertiary", tertiaryColor);
      document.documentElement.style.setProperty("--font", fontColor);
    },
  },
  computed: {
    selectOption() {
      return [
        "Admin",
        "Tenant",
        "Seller",
        "Distributor",
        "Dealer",
        "Manufacturer",
        "Sub Dealer",
      ];
    },
    tenantList() {
      let listdata = this.$store.getters["tenant/GetTenantLiteList"];
      listdata.map((object) => {
        object["name"] = object.company ? object.company.name : "";
      });
      return listdata;
    },
    isTenantSubdomain() {
      return this.domain?.indexOf(".web.nipige.com") != -1;
    },
  },
  mounted() {
    sessionStorage.clear();
    this.GetTenantList();
    // this.domain = "https://valley.dev.web.nipige.com/";
    this.domain = window.location.host;
    this.getTenantDetails();
  },
};
</script>
<style scoped>
.authentication-bg {
  background-image: url("/img/bg-pattern-light.svg");
  background-size: cover;
  background-position: center;
}

.bg-primary {
  background-color: var(--primary) !important;
}

.card-header:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 30px 5px !important;
}

.btn-primary {
  background: var(--primary) !important;
  border: none !important;
  border-radius: 2px !important;
  box-shadow: 0px 1px 5px 1px #989ff0 !important;
}

.form-control {
  height: calc(1.5em + 0.75rem + 10px) !important;
}

.card {
  border: none !important;
  box-shadow: 0px 1px 5px 1px #cdcfea !important;
}

.form-group {
  margin-bottom: 1px;
}

.card-body {
  margin: 6px !important;
}
.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 100px;
  height: 100px;
  background-color: #cdcfea;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: 0;
}
.title-container {
  display: grid;
  place-items: center;
}
.company-title {
  font-weight: bold;
  text-align: center;
  color: var(--primary);
}
.side-logo {
  background-color: var(--primary);
  background-image: url(/img/illustratin_Login.svg);
  background-size: auto;
  background-position: center;
}
.login-left {
  overflow-y: scroll;
  padding: 0;
  height: 100vh;
}
.login-btn {
  width: 100%;
  max-width: 25rem;
}
.login-subtitle {
  margin-left: 0 !important;
  padding: 0 1rem;
}
.login-title {
  font-size: 1.75rem;
}
.input-box {
  display: block;
  width: 100%;
  height: calc(2.2125rem + 8px);
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
.password-toggle-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.password-input-wrapper {
  position: relative;
}
.row-data {
  margin-top: 0px !important;
}

/* Responsive styles for mobile devices */
@media (max-width: 767.98px) {
  .login-left {
    height: auto;
    min-height: 100vh;
    padding: 1rem 0;
  }

  .card-body {
    margin: 1rem !important;
    padding: 1.5rem !important;
  }

  .text-center.w-75 {
    width: 100% !important;
  }

  .login-title {
    font-size: 1.5rem;
    margin-top: 1rem !important;
  }

  .company-title {
    font-size: 1.25rem;
  }

  .login-subtitle {
    font-size: 0.9rem;
    padding: 0 0.5rem;
    margin-top: 0.5rem !important;
    margin-bottom: 1rem !important;
  }

  .circle {
    width: 80px;
    height: 80px;
  }

  .icon {
    width: 80px;
    height: 80px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .login-btn {
    width: 100%;
    max-width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }

  .password-toggle-icon {
    right: 15px;
    top: 20%;
  }

  .text-center.mt-2 {
    margin-top: 1rem !important;
  }

  .text-center img {
    max-width: 120px;
    margin-top: 1rem;
  }
}

@media (max-width: 575.98px) {
  .login-title {
    font-size: 1.25rem;
  }

  .company-title {
    font-size: 1.1rem;
  }

  .login-subtitle {
    font-size: 0.85rem;
  }

  .card-body {
    padding: 1rem !important;
  }

  .circle {
    width: 70px;
    height: 70px;
  }

  .icon {
    width: 70px;
    height: 70px;
  }

  .login-btn {
    font-size: 0.9rem;
    padding: 0.65rem 0.9rem;
  }
}

/* Tablet adjustments */
@media (min-width: 768px) and (max-width: 991.98px) {
  .login-btn {
    max-width: 20rem;
  }
}
</style>